import { cn } from "@/lib/utils";
import { Sparkles } from "lucide-react";

interface WelcomeBannerProps {
  name: string;
  subtitle?: string;
  className?: string;
}

export function WelcomeBanner({ name, subtitle, className }: WelcomeBannerProps) {
  return (
    <div className={cn("welcome-banner relative overflow-hidden", className)}>
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full -translate-y-1/2 translate-x-1/4" />
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-white rounded-full translate-y-1/2 -translate-x-1/4" />
      </div>

      <div className="relative z-10 flex items-center justify-between">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <Sparkles className="h-5 w-5 text-white/80" />
            <span className="text-white/80 text-sm font-medium">
              {new Date().toLocaleDateString("en-US", {
                weekday: "long",
                month: "long",
                day: "numeric",
              })}
            </span>
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-white">
            Welcome back, {name}!
          </h1>
          {subtitle && (
            <p className="text-white/70 mt-2 text-lg">{subtitle}</p>
          )}
        </div>
      </div>
    </div>
  );
}
